import * as React from 'react';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { toast } from 'react-toastify';
import { httpGet, httpPost, httpPut, httpDelete } from '../../HttpRequestHandling/httpRequestHandler';
import { UserRolesResources } from './UserRolesResources';
import EnhancedDataGrid from '../Common/EnhancedDataGrid';
import { GridRowModes, useGridApiRef, GridActionsCellItem,  } from '@mui/x-data-grid';
import AddBoxIcon from '@mui/icons-material/AddBox';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import CancelIcon from '@mui/icons-material/Close';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import DoneIcon from '@mui/icons-material/Done';
import Box from '@mui/material/Box';
import { Check } from '@mui/icons-material';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import RemoveIcon from '@mui/icons-material/Remove';
import RefreshIcon from '@mui/icons-material/Refresh';
import { getFilter, setFilter } from '../Common/Utilities';
import MultiCompanyUserAssignDialog from '../Lookups/MultiCompanyUserAssignDialog';
import { isNewUi } from '../../redesign/uiMode';

var currentEditRow = null;
export default function Resources(props) {

	const companyCode = JSON.parse(localStorage?.userInfo || null)?.companyCode;
	var resourceId = JSON.parse(localStorage?.userInfo || null)?.id;
	const apiGridRef = useGridApiRef();
	const [state,setState] =React.useState({
		data: [],
		companyCode: companyCode,
		filterText:'',
		userRolesList: [],
		openPasswordResetConfirmation: false,
		resetPasswordRowData: null,
		openDeleteConfirmation: false,
		deleteRowData: null,
		selectedRows: [],
		edit: null,
		sortModel: []

	});
	const [currentEditRowId, setCurrentEditRowId] = React.useState(null);
	const [pageSize, setPageSize] = React.useState(10);
	const [rowModesModel, setRowModesModel] = React.useState({});
	const [companyName, setCompanyName] = React.useState(null);
	const [selectedCompanyList, setSelectedCompanyList] = React.useState([]);
	const [openAssignDialog, setOpenAssignDialog] = React.useState(false);
	const [pendingRow, setPendingRow] = React.useState(null);
	const [rolesByCompany, setRolesByCompany] = React.useState({});
	const skipProcessSaveRef = React.useRef(false);
	const [loginRoleNamesForDialog, setLoginRoleNamesForDialog] = React.useState([]);
	const [resultDialogOpen, setResultDialogOpen] = React.useState(false);
	const [resultMessages, setResultMessages] = React.useState({ success: [], failure: [] });
	const [stateUpdate, setStateUpdate] = React.useState([]);
	const [selectedRolesByCompany, setSelectedRolesByCompany] = React.useState({});
	const originalRowBeforeEditRef = React.useRef(null);

	React.useEffect(() => {

		const savedFilterText = getFilter(['SystemSetup', 'UserManagement', 'searchText']) || '';
		const sortModel = getFilter(['SystemSetup', 'UserManagement', 'sortModel']) || [];
		const gridRef = apiGridRef?.current;

		if (gridRef && typeof gridRef.setQuickFilterValues === 'function') {
			gridRef.setQuickFilterValues([savedFilterText]);
		}
		setState((prev) => ({ ...prev, filterText: savedFilterText, sortModel }));

		fetchResources().then((response) => {
			props.inProgress(true);
			
			httpGet("/api/userroles/")
				.then((response) => {
					var userRolesList = response.data;

					setState((prev) => ({ ...prev, userRolesList: userRolesList }));
					props.inProgress(false);

				})
		}).catch((error) => {
			props.inProgress(false);

			toast.error('An error occurred while fetching the records');
			console.error('There was an error!', error);
		});
	}, [])

	const getRefreshButton = React.useCallback((event) => { 
		return <IconButton
			variant="contained"
			onClick={refresh_clickHandler}
			size="small"
			style={{ float: "right", zIndex: 1, marginTop: 10, display: 'none' }}>
			<RefreshIcon />
		</IconButton>;
	}, [state.data, currentEditRowId])

	const refresh_clickHandler = React.useCallback((event) => {
		props.inProgress(true);
		let functionName = "getresources";
		let messageName = "Resources";
		httpGet("/api/Adapter/getSyncData/" + functionName)
			.then(response => {
				var data = response.data;
				props.inProgress(false);
				if (data)
					toast.success(messageName + ' Fetched Successfully');
				else
					toast.error('Error fetching ' + messageName);

			}).catch((error) => {
				props.inProgress(false);
				toast.error('Error fetching ' + messageName);
			});
	}, [])
	const fetchResources = React.useCallback(() => {
		props.inProgress(true);
		var promise = httpGet("/api/resources/")
			.then((response) => {
				var data = response.data;
				var rowId = 1;

				data.map(row => row.rowId = rowId++);

				props.inProgress(false);

				setState((prev) =>({ ...prev, data: data }));
			}).catch((error) => {
				props.inProgress(false);

				toast.error('An error occurred while fetching the records');
				console.error('There was an error!', error);
			});

		return promise;
	}, [])

	const companyMap = React.useMemo(() => {
		const map = {};
		if (companyName) map[state.companyCode] = companyName;
		(selectedCompanyList || []).forEach(c => {
			map[c.companyCode] = c.companyName;
		});
		return map;
	}, [companyName, selectedCompanyList, state.companyCode, stateUpdate]);

	const saveResources = React.useCallback((newdata, oldData) => {
		return new Promise((resolve, reject) => {
			let rowdata = structuredClone(newdata);

			if (newdata.isNew) rowdata.rowId = 0;
			rowdata.companyCode = parseInt(state.companyCode);

			if (rowdata.apadUserRolesResource && rowdata.apadUserRolesResource.length > 0) {
				rowdata.apadUserRolesResource = rowdata.apadUserRolesResource.map(role => ({
					...role,
					resourceId: role.resourceId ? role.resourceId : rowdata.resourceId,
				}));
			}

			let body;
			if (Array.isArray(rowdata.userCompanyLists) && rowdata.userCompanyLists.length > 0) {
				const { userCompanyLists, ...resource } = rowdata;
				body = { resource, userCompanyLists };
			} else {
				body = { resource: rowdata, userCompanyLists: [] };
			}

			const httpMethod = rowdata.rowId === 0 ? httpPost : httpPut;
			props.inProgress(true);

			httpMethod("/api/resources/", body)
				.then((response) => {
					props.inProgress(false);
					const result = response.data || {};

					const failedCompanies = result.failedCompanies || [];
					const successfulCompanies = result.successfulCompanies || [];
					setStateUpdate(result);

					const failedNames = failedCompanies.map(item => {
						const [code, reason] = item.toString().split(":").map(x => x.trim());
						const name = companyMap[code] || ``;
						return reason ? `${name}: ${reason}` : `${name}: Unknown error`;
					});
					
					const successNames = successfulCompanies.map(code => companyMap[code] || ``);
					fetchResources();

					const isMultiCompany =
						(Array.isArray(rowdata.userCompanyLists) && rowdata.userCompanyLists.length > 0) ||
						(successfulCompanies.length + failedCompanies.length) > 1;

					if (isMultiCompany && (failedNames.length > 0 || successNames.length > 0)) {
						setResultMessages({ success: successNames, failure: failedNames });
						setResultDialogOpen(true);
					} else {
						const currentCo = companyMap[state.companyCode] || "";
						toast.success(`User saved Successfuly`);
					}

					setCurrentEditRowId(null);
					setRowModesModel(prev => ({
						...prev,
						[rowdata.rowId]: { mode: GridRowModes.View, ignoreModifications: true },
					}));
					setState(prev => ({ ...prev, edit: null }));

				})
				.catch((error) => {
					props.inProgress(false);

					let backendMessage =
						error?.response?.data?.message ||
						error?.response?.data ||
						error?.message ||
						"Unknown error";

					const lower = backendMessage.toLowerCase();

					if (lower.includes("duplicate entry") || lower.includes("unique constraint"))
						backendMessage = "Failed to save user — a record with the same Resource ID already exists.";
					else if (lower.includes("timeout"))
						backendMessage = "Failed to save user — operation timed out.";
					else if (lower.includes("permission"))
						backendMessage = "Failed to save user — insufficient permissions.";
					else backendMessage = `Failed to save user — ${backendMessage}`;

					toast.error(backendMessage);
					reject(error);
				});
		});
	}, [state.companyCode, fetchResources, props, state.data, companyMap]);


	const deleteResources = React.useCallback(() => {
		props.inProgress(true);
		let data = state.deleteRowData;
		setState((prev) => ({ ...prev, openDeleteConfirmation: false, deleteRowData: null }));
		httpDelete("/api/resources?resourceId=" + encodeURIComponent(data.resourceId))
			.then((response) => {
				props.inProgress(false);
				toast.success('Deleted Successfully');
				fetchResources();
			}).catch((error) => {
				props.inProgress(false);

				if (error.response.data.includes("Cannot delete, record being referenced by other entities.")) {
					toast.error("Cannot delete, record being referenced by other entities.");
				}
				else {
					toast.error(<div>Delete Failed<br />{error.response.data}</div>);
				}
			});
	}, [state.deleteRowData])

	const isRecordValid = React.useCallback((data) => {
		var returnValue = true;
		var message = "";

		const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

		if (data.resourceId === null || data.resourceId === undefined || data.resourceId.trim().length === 0) {
			message += "Resource Id, ";
		}
		if (data.nameFirst === null || data.nameFirst === undefined || data.nameFirst.trim().length === 0) {
			message += "First Name, ";
		}
		if (data.nameLast === null || data.nameLast === undefined || data.nameLast.trim().length === 0) {
			message += "Last Name, ";
		}
		if (data.email && data.email.trim().length > 0 && !regex.test(data.email.toLowerCase())) {
			message += "valid Email, ";
		}
		if (data.loginId === null || data.loginId === undefined || data.loginId.trim().length === 0) {
			message += "Login Id, ";
		}
		if (!data.apadUserRolesResource || data.apadUserRolesResource.length === 0) {
			toast.error("Please assign at least one user group.");
			return false;
		}

		if (message.length > 0) {
			message = message.substr(0, message.length - 2);

			if (message.indexOf(", ") !== -1) {
				var index = message.lastIndexOf(",");
				message = message.substring(0, index) + " and" + message.substring(index + 1);
			}

			toast.error("Please Provide " + message);

			returnValue = false;
		}
		const rows = Array.isArray(state?.data) ? state.data : [];
		const thisRowId = data?.rowId;

		const norm = (v) => (v ?? "").toString().trim();
		const normLower = (v) => norm(v).toLowerCase();

		const resourceIdVal = norm(data?.resourceId);
		const loginVal = normLower(data?.loginId);
		const emailVal = normLower(data?.email); // optional

		// 1) Resource Id must be unique
		if (resourceIdVal.length > 0) {
			const dupResId = rows.some(r =>
				r?.rowId !== thisRowId &&
				norm(r?.resourceId) === resourceIdVal
			);
			if (dupResId) {
				toast.error("Resource ID already exists.");
				return false;
			}
		}
		// 2) Email is optional, but if present it must be unique (case-insensitive)
		if (emailVal.length > 0) {
			const dupEmail = rows.some(r => {
				const otherEmail = normLower(r?.email);
				return r?.rowId !== thisRowId && otherEmail.length > 0 && otherEmail === emailVal;
			});
			if (dupEmail) {
				toast.error("Email Address already exists.");
				return false;
			}
		}

		// 3) Login must be unique (case-insensitive)
		if (loginVal.length > 0) {
			const dupLogin = rows.some(r =>
				r?.rowId !== thisRowId &&
				normLower(r?.loginId) === loginVal
			);
			if (dupLogin) {
				toast.error("Login id already exists.");
				return false;
			}
		}

		return returnValue;
	}, [state?.data])

	const getUserRoleName = React.useCallback((apadUserRolesResource) => {
		var assignedUserRolesResources = "";

		if (state.userRolesList.length > 0 && apadUserRolesResource && apadUserRolesResource.length > 0) {
			const more = apadUserRolesResource.length - 1; // new UI: "AP Clerks +1" rather than "AP Clerks..." (R17)
			assignedUserRolesResources = state.userRolesList.find(ur => ur.userRoleId === apadUserRolesResource[0].userRoleId).userRoleName + (more > 0 ? (isNewUi() ? ` +${more}` : "...") : "");
		}

		return assignedUserRolesResources;
	}, [state,state.edit])

	const getUserRoleNameCSV = React.useCallback( (apadUserRolesResource) => {
		var assignedUserRolesResources = [];
		if (state.userRolesList.length > 0 && apadUserRolesResource && apadUserRolesResource.length > 0) {
			apadUserRolesResource.map((userRolesResource, index) => (
				assignedUserRolesResources.push(state.userRolesList.find(ur => ur.userRoleId === userRolesResource.userRoleId).userRoleName)
			))
		}

		return assignedUserRolesResources.join(", ");
	}, [state, state.edit])

	const getUserRoleNameList = React.useCallback((apadUserRolesResource) => {
		return (<ul key={2} style={{ margin: 0, pading: 0, listStyle: 'none' }}> {(apadUserRolesResource)
			.map((e, ei) => {
				let rolename = state.userRolesList.find(ur => ur.userRoleId === e.userRoleId)?.userRoleName;
				return (rolename && <li key={ei}>{rolename}</li>) || <></>
			})}</ul>)
	}, [state, state.edit])

	const selectedUserRoles_onClose = React.useCallback((selectedUserRoles) => {
		if (selectedUserRoles) {
			var apadUserRolesResource = [];

			selectedUserRoles.map((userRolesResource) => (
				apadUserRolesResource.push({
					companyCode: userRolesResource.companyCode,
					resourceId: currentEditRow?.resourceId || "",
					userRoleId: parseInt(userRolesResource.userRoleId, 10)
				})
			));

			currentEditRow.apadUserRolesResource = apadUserRolesResource;

			if (apiGridRef?.current) {
				apiGridRef.current.setEditCellValue({
					id: currentEditRow.rowId,
					field: "apadUserRolesResource",
					value: apadUserRolesResource
				});
			}

			setState((prev) => ({
				...prev,
				edit: { ...prev.edit, apadUserRolesResource }
			}));
		}
	}, [state]);


	const resources_resetPasswordClickHandler = React.useCallback((rowData) => {
		setState((prev) => ({ ...prev, openPasswordResetConfirmation: true, resetPasswordRowData: rowData }));
	}, [])


	const resources_DeleteClickHandler = React.useCallback((rowData) => {
		setState((prev) => ({ ...prev, openDeleteConfirmation: true, deleteRowData: rowData }));
	}, [])

	const closeDialog = React.useCallback( (event) => {
		setState((prev) => ({ ...prev, openPasswordResetConfirmation: false, resetPasswordRowData: null }));
	}, [])


	const closeDeleteDialog = React.useCallback((event) => {
		setState((prev) => ({ ...prev, openDeleteConfirmation: false, deleteRowData: null }));
	}, [])


	const resetPasswordYes_clickHandler = React.useCallback((event) => {
		var rowData = state.resetPasswordRowData;
		const email = (rowData.email || "").toString().trim();

		if (!email) {
			toast.error("Email address is required to reset the password. Please add an email and try again.");
			return;
		}
		var url = "/api/resources/resetpassword/";

		setState((prev) => ({ ...prev, openPasswordResetConfirmation: false, resetPasswordRowData: null }));

		props.inProgress(true);

		httpPost(url, rowData)
			.then((response) => {
				props.inProgress(false);

				toast.success('Password reset Successfully');
			}).catch((error) => {
				props.inProgress(false);

				toast.error('Password reset Failed');
			});
	}, [state])



	/////////////////////////////////////////////////////////

	const getAddButton = React.useCallback(() => {
		return <IconButton
			key={1 }
			disabled={!!currentEditRowId }
			variant="contained"
			onClick={handleAddClick}
			size="small"
			style={{ float: "right", zIndex: 1, marginTop: 10 }}
		>
			<Tooltip key={1} title={'add'}><AddBoxIcon key={2} /></Tooltip>
		</IconButton>;
	}, [state.data, currentEditRowId])


	const handleAddClick = React.useCallback(() => {
		if (apiGridRef.current?.setQuickFilterValues) {
			apiGridRef.current.setQuickFilterValues(['']);
		}
		const id = ([...state.data]?.sort((a,b)=>b.rowId-a.rowId)[0]?.rowId + 1) || 1;
		//apiGridRef.current.setPage(Math.ceil((state.data.length+1) / pageSize));
		let model = {};
		model.rowId = id;
		model.isNew = true;
		let field = 'resourceId';
		setCurrentEditRowId(id);
		setState((prev) => ({
			...prev, isDirty: true, data: [ model,...prev.data]
		}));
		apiGridRef.current.setPage(0);
		setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit, fieldToFocus: field } })
		//apiGridRef.current.startRowEditMode({ id: id, fieldToFocus: field });
		
	}, [state.data]);

	const processRowUpdate = React.useCallback((newrow, oldrow) => {
		if (skipProcessSaveRef.current) {
			skipProcessSaveRef.current = false;
			return newrow;
		}
		let _newrow = structuredClone(newrow);
		if (!isRecordValid(_newrow)) {
			setRowModesModel({ ...rowModesModel, [_newrow.rowId]: { mode: GridRowModes.Edit } })
			throw new Error('')
		}
		setCurrentEditRowId(null);
		_newrow.apadUserRolesResource = state.edit?.apadUserRolesResource
			|| currentEditRow.apadUserRolesResource;
		setState((prev) => ({ ...prev, edit: null }))

		return saveResources(_newrow, oldrow)
			.then(() => {
				setRowModesModel((prev) => ({
					...prev,
					[_newrow.rowId]: { mode: GridRowModes.View }
				}));
				return newrow;
			})
			.catch(() => {
				setRowModesModel((prev) => ({
					...prev,
					[_newrow.rowId]: { mode: GridRowModes.Edit }
				}));

			});
	}, [state, state.edit])

	const handleRowClick = React.useCallback((params, event) => {
		if (!params.isEditable) {
			return;
		}
		if (!event.currentTarget.contains(event.target)) {
			return;
		}
		if (params.cellMode == GridRowModes.View) 
		{
			apiGridRef.current.startRowEditMode({ id: params.id });
		}
	}, [state])

	const handlePageSizeChange = React.useCallback((newpagesize) => {
		setPageSize((prev) => (newpagesize));
	},[state])




	const handleEditClick = (id) => {
		const originalRow = (state.data || []).find(r => r.rowId === id) || null;
		originalRowBeforeEditRef.current = originalRow ? { ...originalRow } : null;

		setCurrentEditRowId(id);
		setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
	};

	const handleSaveClick = async (newData) => {
		if (!isRecordValid(newData)) return;
		skipProcessSaveRef.current = true;

		const isUpdate = !newData.isNew;

		const userInfo = JSON.parse(localStorage?.userInfo || "null") || {};
		const loggedInResourceId = userInfo.id || "";

		let apadResourceForSp;
		if (!isUpdate) {
			apadResourceForSp = {
				companyCode: userInfo.companyCode ?? Number(state.companyCode),
				resourceId: userInfo.id || "",
			};
		} else {
			apadResourceForSp = {
				companyCode: newData.companyCode ?? Number(state.companyCode),
				resourceId: newData.resourceId,
			};
		}

		try {
			const companiesOther = await fetchUserGroupList(apadResourceForSp, loggedInResourceId);
			const hasOtherCompanies =
				Array.isArray(companiesOther) && companiesOther.length > 0;

			if (hasOtherCompanies) {
				const normalizedPendingRow = {
					...newData,
					isNew: !!newData.isNew
				};

				setPendingRow(normalizedPendingRow);
				setLoginRoleNamesForDialog(
					(state.userRolesList || [])
						.filter(role =>
							(newData.apadUserRolesResource || [])
								.some(r => r.userRoleId === role.userRoleId)
						)
						.map(r => r.userRoleName)
				);
				setOpenAssignDialog(true);
				return;
			}


			const response = await saveResources(newData);
			const resData = response?.data || response || {};
			const backendMsg = resData?.message || "User saved successfully";
			const failedCompanies = resData?.failedCompanies || [];

			setRowModesModel(prev => ({
				...prev,
				[newData.rowId]: { mode: GridRowModes.View },
			}));

			if (failedCompanies.length > 0) {
				const [code, reason] = failedCompanies[0]
					.toString()
					.split(":")
					.map(x => x.trim());
				const company = companyMap[code] || "";
				toast.error(
					`Failed to save user for ${company}: ${reason || "Unknown error"}`
				);
			} else {
				toast.success(backendMsg);
			}
		} catch (error) {
			let backendMsg =
				error?.response?.data?.message ||
				error?.response?.data ||
				error?.message ||
				"Unknown error";

			const msg = backendMsg.toLowerCase();

			if (msg.includes("duplicate entry") || msg.includes("unique constraint"))
				backendMsg =
					"Failed to save user — a record with the same Resource ID already exists.";
			else if (msg.includes("timeout"))
				backendMsg = "Failed to save user — operation timed out.";
			else if (msg.includes("permission"))
				backendMsg =
					"Failed to save user — insufficient permissions.";
			else backendMsg = `Failed to save user — ${backendMsg}`;

			toast.error(backendMsg);
			setRowModesModel(prev => ({
				...prev,
				[newData.rowId]: { mode: GridRowModes.Edit },
			}));
		}
	};


	const handleCancelClick = (id) => {
		setCurrentEditRowId(null);
		setRowModesModel({
			...rowModesModel,
			[id]: { mode: GridRowModes.View, ignoreModifications: true },
		});
		const editedRow = state.data.find((row) => row.rowId === id);
		//if (editedRow?.isNew) {
		//	apiGridRef.current.setPage(0);

		//}
		setState((prev) => { 
			return (editedRow?.isNew)? { ...prev, edit: null, data: state.data.filter((row) => row.rowId !== id) }
			:{ ...prev, edit: null }
		});
	};

	const fetchUserGroupList = React.useCallback((apadResource, loggedInResourceId) => {
		const uri = `/api/invoicedocument/userGroupList?loggedInResourceId=${loggedInResourceId}`;

		props.inProgress(true);

		return httpPost(uri, apadResource)
			.then((response) => {
				props.inProgress(false);
				const rows = Array.isArray(response.data) ? response.data : [];

				const pickCompanyCode = (x) => Number(x.CompanyCode ?? x.companyCode);
				const pickCompanyName = (x) => (x.CompanyName ?? x.companyName ?? '');
				const pickRoleId = (x) => Number(x.UserRoleId ?? x.userRoleId);
				const pickRoleName = (x) => (x.UserRoleName ?? x.userRoleName ?? '');
				const pickResourceUserRoleId = (x) =>
					x.ResourceUserRoleId ?? x.resourceUserRoleId ?? null;

				const currentCoRow =
					rows.find(x => pickCompanyCode(x) === Number(state.companyCode)) || null;
				setCompanyName(currentCoRow ? pickCompanyName(currentCoRow) : '');

				const rolesMap = rows.reduce((acc, x) => {
					const cc = pickCompanyCode(x);
					const roleId = pickRoleId(x);
					const roleName = pickRoleName(x);
					if (!cc || !roleId || !roleName) return acc;
					if (!acc[cc]) acc[cc] = [];
					acc[cc].push({ roleId, roleName });
					return acc;
				}, {});

				Object.keys(rolesMap).forEach(k => {
					const seen = new Set();
					rolesMap[k] = rolesMap[k].filter(r => {
						const key = `${r.roleId}|${r.roleName}`;
						if (seen.has(key)) return false;
						seen.add(key);
						return true;
					});
				});

				const selectedMap = {};
				rows.forEach(x => {
					const cc = pickCompanyCode(x);
					const roleId = pickRoleId(x);
					const resourceUserRoleId = pickResourceUserRoleId(x);

					if (!cc || !roleId) return;
					if (!resourceUserRoleId) return;

					if (!selectedMap[cc]) selectedMap[cc] = new Set();
					selectedMap[cc].add(roleId);
				});

				const selectedRolesByCompanyObj = {};
				Object.keys(selectedMap).forEach(cc => {
					selectedRolesByCompanyObj[cc] = Array.from(selectedMap[cc]);
				});

				const companiesUniqueMap = new Map();
				rows.forEach(x => {
					const cc = pickCompanyCode(x);
					const cn = pickCompanyName(x);
					if (cc && !companiesUniqueMap.has(cc)) {
						companiesUniqueMap.set(cc, { companyCode: cc, companyName: cn });
					}
				});

				const companiesAll = Array.from(companiesUniqueMap.values());
				const companiesOther = companiesAll.filter(
					c => c.companyCode !== Number(state.companyCode)
				);

				setSelectedCompanyList(companiesOther);
				setRolesByCompany(rolesMap);
				setSelectedRolesByCompany(selectedRolesByCompanyObj); // 👈 NEW

				return companiesOther;
			})
			.catch(() => {
				props.inProgress(false);
				toast.error('Error fetching user group list');
				throw new Error("Error fetching user group list");
			});
	}, [state.companyCode, props.inProgress, companyMap]);



	const handleMultiCompanyUserConfirm = async (dialogPayload) => {
		try {
			setOpenAssignDialog(false);

			if (!pendingRow || !isRecordValid(pendingRow)) {
				toast.error("Please provide all required fields");
				return;
			}

			const currentCode = Number(state.companyCode);
			const userCompanyLists = (dialogPayload.userCompanyLists || []).filter(
				(c) => Number(c.companyCode) !== currentCode
			);

			const currentCompanyRoles = (pendingRow.apadUserRolesResource || [])
				.filter((x) => Number(x.companyCode) === currentCode)
				.map((x) => ({
					companyCode: currentCode,
					userRoleId: x.userRoleId,
					resourceId: pendingRow.resourceId,
				}));

			const payload = {
				...pendingRow,
				companyCode: currentCode,
				apadUserRolesResource: currentCompanyRoles,
				userCompanyLists,
			};

			skipProcessSaveRef.current = true;
			await saveResources(payload, pendingRow);

			setRowModesModel((prev) => ({
				...prev,
				[pendingRow.rowId]: { mode: GridRowModes.View },
			}));
			setPendingRow(null);
		} catch (error) {
			let backendMessage =
				error?.response?.data?.message ||
				error?.response?.data ||
				error?.message ||
				"Unknown error";

			const lower = backendMessage.toLowerCase();
			if (lower.includes("duplicate entry") || lower.includes("unique constraint"))
				backendMessage = "Failed to save user — a record with the same Resource ID already exists.";
			else if (lower.includes("timeout"))
				backendMessage = "Failed to save user — operation timed out.";
			else if (lower.includes("permission"))
				backendMessage = "Failed to save user — insufficient permissions.";
			else backendMessage = `Failed to save user — ${backendMessage}`;

			toast.error(backendMessage);
		}
	};

	const handleMultiCompanyUserClose = () => {
		setOpenAssignDialog(false);
	};

	const selectedRoleNamesFromRow = React.useMemo(() => {
		const currentCode = Number(state.companyCode);


		const roleIdsForCurrentCompany = new Set(
			(pendingRow?.apadUserRolesResource || [])
				.filter(x => Number(x.companyCode) === currentCode)
				.map(x => Number(x.userRoleId))
		);

		if (roleIdsForCurrentCompany.size === 0) return [];


		const catalogForCurrentCompany =
			(rolesByCompany && rolesByCompany[currentCode]) || [];

		const names = catalogForCurrentCompany
			.filter(opt => roleIdsForCurrentCompany.has(Number(opt.roleId)))
			.map(opt => opt.roleName);

		const seen = new Set();
		const uniqueNames = [];
		for (const n of names) {
			if (!n) continue;
			const key = n.toLowerCase();
			if (seen.has(key)) continue;
			seen.add(key);
			uniqueNames.push(n);
		}
		return uniqueNames;
	}, [pendingRow, state.companyCode, rolesByCompany]);


	//////////////////////////////////////////////////////////

		return (
			<div>
				<h1>User Management</h1>
				<div className="form-group">
					<div style={{ display: 'block',overflow: 'auto', width: '100%' }}>
						<EnhancedDataGrid rows={state.data}
							disableColumnMenu
							pagination
							pageSize={10}
							editMode="row"
							onCellClick={handleRowClick}
							processRowUpdate={processRowUpdate}
							onProcessRowUpdateError={(err) => { }}
							disableSelectionOnClick
							apiRef={apiGridRef}
							setFilterText={(text) => {
								const trimmed = text?.trim() || '';
								setState((prev) => ({ ...prev, filterText: trimmed }));
								setFilter(['SystemSetup', 'UserManagement', 'searchText'], trimmed);
							}}
							filterText={state.filterText}
							onSortModelChange={(model) => {
								setState((prev) => ({ ...prev, sortModel: model }));
								setFilter(['SystemSetup', 'UserManagement', 'sortModel'], model);
							}}
							sortModel={state.sortModel}
							customcomponent={
								(<>
									{getRefreshButton()}
									{getAddButton()}									
								</>)
							}
							rowModesModel={rowModesModel}
							columns={[
								{
									headerName: 'User Group',
									field: 'apadUserRolesResource',
									width:200,
									renderCell: rowData => {
										return (<div key={1 }>
											<Tooltip key={2} title={getUserRoleNameList(rowData?.row?.apadUserRolesResource || [])}>
												<Typography variant="inherit">{getUserRoleName(rowData.row.apadUserRolesResource)}</Typography>
											</Tooltip>
										</div>)
									},
									renderEditCell: props => {
										currentEditRow = props.row;

										const info = {
											userRolesList: state.userRolesList,
											apadUserRolesResource: props.row.apadUserRolesResource ? props.row.apadUserRolesResource : []
										};

										return <Box  
											key={1}
											sx={{
												display: 'flex',
												flexDirection: 'row'
											}}>
											<Tooltip key={2} title={getUserRoleNameList((state.edit?.apadUserRolesResource || currentEditRow.apadUserRolesResource) || [])}>
												<Typography key={3} sx={{
													pt:'10px'
												}}
													variant="inherit">{getUserRoleName(state.edit?.apadUserRolesResource || currentEditRow.apadUserRolesResource)}</Typography>
											</Tooltip>
											<UserRolesResources  info={info} onClose={selectedUserRoles_onClose} />
										</Box>
									},
									editable: true
									
								},
								{
									headerName: 'Resource Id',
									field: 'resourceId',
									cellClassName: "MuiInputBase-input MuiInput-input",
									renderCell: (props) => {
										return <span>{props.row.resourceId}</span>
									},
									renderEditCell: (props) => {
										let row = props.row;
										if (!row.isNew) {
											return <span>{row.resourceId}</span>
										} else {
											return <input
												type="text"
												aria-invalid="false"
												placeholder=""
												value={row.resourceId || ''}
												className="MuiInputBase-input MuiInput-input"
												style={{ width: '100%' }}
												onChange={(event) => {
													const newValue = event.target.value;
													const { id, api, field, value } = props;// The new value entered by the user
													api.setEditCellValue({ id, field, value: newValue })
												}
												}
											/>
										}
									},
									width: 100,
									editable: true,
								},
								{
									headerName: 'First Name',
									field: 'nameFirst',
									editable: true,
									width: 200
								},
								{
									headerName: 'Last Name',
									field: 'nameLast',
									editable: true,
									width: 200
								},
								{
									headerName: 'Name Initial',
									field: 'nameInit',
									editable: true,
									width: 100
								},
								{
									headerName: 'Title',
									field: 'title',
									editable: true,
									flex: 1
								},
								{
									headerName: 'Email',
									field: 'email',
									editable: true,
									width: 200
								},
								{
									headerName: 'Login',
									field: 'loginId',
									editable: true,
									width: 200
								},
								{
									headerName: 'Active',
									field: 'activeFlag',
									type: 'boolean',
									width: 80,
									headerAlign: 'center',
									align: 'center',
									renderCell: (props) => {
										return (
											(props?.row?.activeFlag) ?
												<Check key={props?.row?.rowId} color={'action'} /> :
												<RemoveIcon key={props?.row?.rowId} color={'action'} />

										)
									},
									renderEditCell: props => (
										<Checkbox
											key={props.row.rowId}
											color="default"
											checked={props.value}
											onChange={e => {
												const newValue = e.target.checked;
												const { id, api, field, value } = props;// The new value entered by the user
												api.setEditCellValue({ id, field, value: newValue })

											}
											}
										/>
									),
									editable: true,

								},
								{
									field: 'actions',
									type: 'actions',
									headerName: 'Actions',
									width: 120,
									cellClassName: 'actions',
									getActions: (rowData) => {
										const isInEditMode = rowModesModel[rowData.id]?.mode === GridRowModes.Edit;

										if (isInEditMode) {
											return [
												<GridActionsCellItem
													key={rowData.id + 1}
													icon={<Tooltip key={rowData.id + 2} title={'Save'}>
														<DoneIcon key={rowData.id + 1} />
													</Tooltip>}
													label="Save"
													color="inherit"
													onClick={() => {
														const updatedRow = apiGridRef.current.getRowWithUpdatedValues(rowData.id);
														handleSaveClick(updatedRow);
													}}


												/>,
												<GridActionsCellItem
													key={rowData.id + 2}
													icon={<Tooltip key={rowData.id + 2} title={'Cancel'}>
														<CancelIcon key={rowData.id + 1} />
													</Tooltip>}
													label="Cancel"
													className="textPrimary"
													onClick={() => { handleCancelClick(rowData.id) }}
													color="inherit"
												/>,
											];
										}
										
										const isSso = !!localStorage.actualSsoType;
										const isSourceNexelus = localStorage.systemType === 'nexelus';
										const showResetPasswordButton = isSourceNexelus ? false : !isSso;
										return [
											...(showResetPasswordButton? [<GridActionsCellItem
												key={rowData.id + 1}
												icon={<Tooltip key={rowData.id + 2} title={'Reset Password'}>
													<VpnKeyIcon key={rowData.id + 1} />
												</Tooltip>}
												label="Reset Password"
												className="textPrimary"
												onClick={() => { resources_resetPasswordClickHandler(rowData.row) }}
												color="inherit"
												disabled={currentEditRowId && currentEditRowId !== rowData.id}
											/>] : []),
											<GridActionsCellItem
												key={rowData.id + 2}
												icon={<Tooltip key={rowData.id + 2} title={'Edit'}>
													<EditIcon key={rowData.id + 1} />
												</Tooltip>}
												label="Edit"
												className="textPrimary"
												onClick={() => { handleEditClick(rowData.id) }}
												color="inherit"
												disabled={currentEditRowId && currentEditRowId !== rowData.id}
											/>,
											<GridActionsCellItem
												key={rowData.id + 3}
												icon={<Tooltip key={rowData.id + 2} title={'Delete'}>
													<DeleteIcon key={rowData.id + 1} />
												</Tooltip>}
												label="Delete"
												onClick={() => { resources_DeleteClickHandler(rowData.row) }}
												color="inherit"
												disabled={currentEditRowId && currentEditRowId !== rowData.id}
											/>,
										];
									},
								},

							]}
							onPageSizeChange={handlePageSizeChange }
							getRowId={(row) => row.rowId}
							editable={
								{
									onRowAdd: newData =>
										new Promise((resolve, reject) => {
											newData.rowId = 0;
											newData.companyCode = parseInt(state.companyCode);

											if (isRecordValid(newData)) {
												newData.apadUserRolesResource = that.currentEditRow.apadUserRolesResource;

											}
											else {
												reject();
											}
										}),
									onRowUpdate: (newData, oldData) =>
										new Promise((resolve, reject) => {

											if (isRecordValid(newData)) {
												newData.apadUserRolesResource = that.currentEditRow.apadUserRolesResource;

											}
											else {
												reject();
											}
										}),
									onRowDelete: oldData =>
										new Promise((resolve, reject) => {
											deleteResources(oldData, resolve, reject);
										}),
									onRowAddCancelled: rowData =>
										new Promise((resolve, reject) => {
											setState({ selectedUserRoleIds: [], initializeSelectedUserRoleIds: true });
										}),
									onRowUpdateCancelled: rowData =>
										new Promise((resolve, reject) => {
											setState({ selectedUserRoleIds: [], initializeSelectedUserRoleIds: true });
										})
								}
							}
						/>
					</div>

				</div>
				<MultiCompanyUserAssignDialog
					open={openAssignDialog}
					onClose={handleMultiCompanyUserClose}
					onConfirm={handleMultiCompanyUserConfirm}
					currentCompanyCode={state.companyCode}
					companies={selectedCompanyList}
					userRolesByCompany={rolesByCompany}
					loginCompanyRoleNames={loginRoleNamesForDialog}
					baseUserPayload={pendingRow || {}}
					loading={false}
					selectedRolesByCompany={selectedRolesByCompany}
				/>

				{resultDialogOpen && (
					<Dialog open fullWidth maxWidth="sm">
						<DialogTitle>User Save Results</DialogTitle>
						<DialogContent dividers>
							{resultMessages.success.length > 0 && (
								<div style={{ marginBottom: "10px" }}>
									{resultMessages.success.map((company, index) => (
										<div
											key={`success-${index}`}
											style={{
												color: "green",
												fontSize: "16px",
												marginBottom: "6px",
											}}
										>
											User successfully saved in {company}.
										</div>
									))}
								</div>
							)}

							{resultMessages.failure.length > 0 && (
								<div style={{ marginBottom: "10px" }}>
									{resultMessages.failure.map((entry, index) => {
										const [companyName, reasonRaw] = entry.split(":").map(p => p.trim());
										const reason = reasonRaw || "Unknown error";
										return (
											<div
												key={`fail-${index}`}
												style={{ color: "red", fontSize: "16px", marginBottom: "6px" }}
											>
												Failed to save user for {companyName} ({reason})
											</div>
										);
									})}
								</div>
							)}
						</DialogContent>
						<DialogActions>
							<Button
								onClick={() => {
									setResultDialogOpen(false);
								}}
							>
								Close
							</Button>
						</DialogActions>
					</Dialog>
				)}


				<Dialog
					open={state.openPasswordResetConfirmation}
					aria-labelledby="draggable-dialog-title"
				>
					<DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
						Reset Password
					</DialogTitle>
					<DialogContent>
						<DialogContentText>
							Are you sure you want to reset password for login id "{state.resetPasswordRowData ? state.resetPasswordRowData.loginId : ""}" ?
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={resetPasswordYes_clickHandler} color="primary">
							Yes
						</Button>
						<Button autoFocus onClick={closeDialog} color="primary">
							No
						</Button>
					</DialogActions>
				</Dialog>


				<Dialog
					open={state.openDeleteConfirmation}
					aria-labelledby="draggable-dialog-title"
				>
					<DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
						Delete Record
					</DialogTitle>
					<DialogContent>
						<DialogContentText>
							Are you sure you want to delete the login id "{state.deleteRowData ? state.deleteRowData.loginId : ""}" ?
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={deleteResources} color="primary">
							Yes
						</Button>
						<Button autoFocus onClick={closeDeleteDialog} color="primary">
							No
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		);

} 